var TableActionType;
(function (TableActionType) {
  TableActionType["SELECT_ALL"] = "SELECT_ALL";
  TableActionType["DESELECT_ALL"] = "DESELECT_ALL";
  TableActionType["SELECT_ROW"] = "SELECT_ROW";
  TableActionType["DESELECT_ROW"] = "DESELECT_ROW";
  TableActionType["CLEAR_FILTERED"] = "CLEAR_FILTERED";
  TableActionType["SET_FILTERED"] = "SET_FILTERED";
  TableActionType["SET_SELECTED"] = "SET_SELECTED";
  TableActionType["SELECT_FILTERED"] = "SELECT_FILTERED";
  TableActionType["DESELECT_FILTERED"] = "DESELECT_FILTERED";
})(TableActionType || (TableActionType = {}));
function selectAll(sortedData) {
  return {
    payload: sortedData,
    type: TableActionType.SELECT_ALL
  };
}
function deselectAll(sortedData) {
  return {
    type: TableActionType.DESELECT_ALL
  };
}
function selectFiltered(sortedData) {
  return {
    payload: sortedData,
    type: TableActionType.SELECT_FILTERED
  };
}
function deselectFiltered(sortedData) {
  return {
    payload: sortedData,
    type: TableActionType.DESELECT_FILTERED
  };
}
function selectRow(payload) {
  return {
    payload: payload,
    type: TableActionType.SELECT_ROW
  };
}
function deselectRow(payload) {
  return {
    payload: payload,
    type: TableActionType.DESELECT_ROW
  };
}
function clearFiltered() {
  return {
    type: TableActionType.CLEAR_FILTERED
  };
}
function setFiltered(filtered) {
  return {
    payload: filtered,
    type: TableActionType.SET_FILTERED
  };
}
function setSelected(selected) {
  return {
    payload: selected,
    type: TableActionType.SET_SELECTED
  };
}

export { TableActionType, clearFiltered, deselectAll, deselectFiltered, deselectRow, selectAll, selectFiltered, selectRow, setFiltered, setSelected };
